<template>
  <div>
    <Loader v-if="isLoading"></Loader>
    <div v-else-if="!isLoading && $route.name === 'FirmUpdate'">
      <b-row>
        <b-col>
          <router-link v-if="prevRoute === 'FirmShow' && retrieved" :to="{ name: 'FirmShow', params: { id: retrieved['@id'] } }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToShow') }}</router-link>
          <router-link v-else :to="{ name: 'FirmList', query: {p: currentPage} }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <FirmForm
              v-if="item"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations"
              :initial-values="retrieved" />
          </b-card>
        </b-col>
      </b-row>
    </div>
    <b-row v-else>
      <FirmForm
        v-if="item"
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :errors="violations"
        :initial-values="retrieved" />
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FirmForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    FirmForm,
    Loader
  },

  props: ['idUserData'],

  data () {
    return {
      prevRoute: '',
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'userdata/update/isLoading',
      error: 'userdata/update/error',
      deleteError: 'userdata/del/error',
      deleteLoading: 'userdata/del/isLoading',
      created: 'userdata/create/created',
      deleted: 'userdata/del/deleted',
      retrieved: 'userdata/update/retrieved',
      updated: 'userdata/update/updated',
      violations: 'userdata/update/violations',
      currentPage: 'userdata/list/currentPage'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'FirmList' })
    },

    updated: function () {
      this.$router.push({ name: 'FirmShow', params: { id: this.updated['@id'] } })
    },

    retrieved: function (retrieved) {
      if (this.retrieved.idClientType && this.retrieved.idClientType['@id']) {
        this.retrieved.idClientType = this.retrieved.idClientType['@id']
      }
      if (this.retrieved.status && this.retrieved.status['@id']) {
        this.retrieved.status = this.retrieved.status['@id']
      }
      if (this.retrieved.salesOpportunity && this.retrieved.salesOpportunity['@id']) {
        this.retrieved.salesOpportunity = this.retrieved.salesOpportunity['@id']
      }
      if (this.retrieved.workplace && this.retrieved.workplace['@id']) {
        this.retrieved.workplace = this.retrieved.workplace['@id']
      }
      if (this.retrieved.idSalesRepresentative && this.retrieved.idSalesRepresentative['@id']) {
        this.retrieved.idSalesRepresentative = this.retrieved.idSalesRepresentative['@id']
      }
      if (this.retrieved.userDataEmployees) {
        delete this.retrieved.userDataEmployees
      }
      if (this.retrieved.userDataFirms) {
        delete this.retrieved.userDataFirms
      }
      if (this.retrieved.users) {
        delete this.retrieved.users
      }
      if (!this.retrieved.userEmail && this.retrieved.contactEmail) {
        this.retrieved.userEmail = this.retrieved.contactEmail
        this.retrieved.contactEmail = ''
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  created () {
    if (this.idUserData) {
      this.retrieve(this.idUserData)
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      createReset: 'userdata/create/reset',
      deleteItem: 'userdata/del/del',
      delReset: 'userdata/del/reset',
      retrieve: 'userdata/update/retrieve',
      updateReset: 'userdata/update/reset',
      update: 'userdata/update/update',
      updateRetrieved: 'userdata/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this userdata ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      let item = this.$store.state.userdata.update.retrieved
      item.phoneMobileToSms = parseInt(item.phoneMobileToSms)
      item.userDataTags = item.userDataTags.map(entry => {
        return { '@id': entry['@id'], idTag: entry.value, idUserData: item['@id'], text: entry.text, value: entry.value }
      })
      item.maxOpenCasesForPartnerAllowed = parseInt(item.maxOpenCasesForPartnerAllowed)
      // if (item.idClientType) {
      //   item.idClientType = item.idClientType['@id']
      // }
      // if (item.users) {
      //   delete item.users
      // }
      // if (item.userDataEmployees) {
      //   delete item.userDataEmployees
      // }
      // if (item.userDataFirms) {
      //   delete item.userDataFirms
      // }
      this.$store.state.userdata.update.retrieved = item
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
